export default "__VITE_ASSET__632258ff__"